exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-group > i {\n  padding-left: 2.5px;\n  padding-right: 2.5px;\n}\n.text-content > p {\n  margin-bottom: 0 !important;\n}\n", ""]);

// exports
